import { render, staticRenderFns } from "./blessingTiger.vue?vue&type=template&id=55a89c54"
import script from "./blessingTiger.vue?vue&type=script&lang=js"
export * from "./blessingTiger.vue?vue&type=script&lang=js"
import style0 from "./blessingTiger.vue?vue&type=style&index=0&id=55a89c54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports